import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, switchMap, take, tap } from 'rxjs';
import {Profile} from "./profile.types";
import {User} from "../../users/users.types";


@Injectable({
    providedIn: 'root'
})
export class UserProfileService
{
    // Private
    private _profile: BehaviorSubject<Profile | null> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for user
     */
    get profile$(): Observable<Profile>
    {
        return this._profile.asObservable();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get profile of logged user
     */
    getLoggedUser(): Observable<Profile>
    {
        return this._httpClient.get<Profile>(`api/auth/logged-user`).pipe(
            tap((profile) => {
                this._profile.next(profile);
            })
        );
    }

    /**
     * Update user
     *
     * @param id
     * @param user
     */
    updateProfile(id: string, user: User): Observable<User>
    {
        return this.profile$.pipe(
            take(1),
            switchMap(profile => this._httpClient.put<User>(`api/user/${id}`, user).pipe(
                map((updatedProfile) => {


                    // Update the profile
                    this._profile.next(updatedProfile);

                    return updatedProfile;
                })
            ))
        );
    }

}
